import { StandardEquipment } from '../../../../../../../types';

type Props = {
	standardEquipment: StandardEquipment[];
};

export const setGroupedItems = ({ standardEquipment }: Props) =>
	standardEquipment.reduce(
		(acc, item) => {
			if (!acc[item.group]) {
				acc[item.group] = [];
			}
			acc[item.group].push(item.descriptions[0]);
			return acc;
		},
		{} as Record<string, string[]>
	);
